import { TPermission } from 'src/pages/configuration/permissions/_components/permissions.type'
import { TNavigationLocales } from './locales'

export enum EUserRole {
  SALES = 'sales',
  ADMIN = 'admin',
  USER = 'user',
}
export const USER_ROLE = Object.values(EUserRole)

export enum EUserTitle {
  M = 'M.',
  MME = 'Mme.',
  DR = 'Dr.',
  PR = 'Pr.',
}
export const USER_TITLES = Object.values(EUserTitle)

export const USER_LOCALES = [
  { locale: 'french', code: 'fr' },
  { locale: 'english', code: 'en' },
]

export enum EUserProjectJob {
  DOCTOR = 'doctor',
  LAB = 'lab',
  PARAMED = 'paramed',
  OTHER = 'other',
}
export const USER_PROJECT_JOBS = Object.values(EUserProjectJob)

export type TUser = {
  id: number
  title?: EUserTitle
  firstname?: string
  lastname?: string
  email?: string
  phone?: string | null
  nationalRegisterID?: string
  consentSolicitation?: boolean
  speciality?: string
  civility?: string
  businessID?: string
  companyName?: string
  street?: string
  zipcode?: string
  city?: string
  companyPhone?: string
  companyEmail?: string
  locale?: TNavigationLocales
  verified?: boolean
  role?: EUserRole
  membership?: string
  isActive?: boolean
  secretariat?: TSecretariat
  UserProject?: TUserProject
  generalTerms?: string
  username?: string
  isEmailVerified?: boolean
}

export type TUserProject = {
  PermissionId?: number
  UserId: number
  isActive: boolean
  Permission?: TPermission
  User?: TUser
  UserAuth?: TUserAuth
}

export type TUserAuth = {
  failedLoginCount?: number
  isEmailVerified?: boolean
  lastFailedLoginAttemptAt?: string | null
}

export type TSecretariat = {
  phone?: string
  mail?: string
  firstname?: string
  lastname?: string
}
